module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/dashboard/Layout.ejs -->\n<div class="employer-dashboard">\n\n    <div class="js-dashboard-header"></div>\n    <div class="js-dashboard-content">\n        <div class="row panels">\n            <div class="js-dashboard-employees col-lg-12"></div>\n        </div>\n\n        <div class="row panels">\n            <div class="js-dashboard-action-log col-lg-12 m-b-lg"></div>\n        </div>\n    </div>\n\n    <div class="js-layout-loader loader">\n        '+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'\n    </div>\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/dashboard/Layout.ejs
// module id = 1012
// module chunks = 1